import React from "react";

const Experts: React.FC = () => {
  const certifications = ["Standard Welding"];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl font-bold mb-4">Meet welding Experts</h2>
            <p className="text-gray-600 mb-8">
              Besides our experts are good welding, they are skilled, licensed
              and certified.
            </p>

            <div className="mb-8">
              <h3 className="text-xl font-semibold mb-4">
                holds the following standards:
              </h3>
              <div className="space-y-3">
                {certifications.map((cert, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="text-orange-500">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <span className="text-gray-700">{cert}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Certification Badges */}
            <div className="flex space-x-6">
              <img
                src="/rec-image-2.png"
                alt="2017 Certification"
                className="w-24 h-24"
              />
              <img
                src="/rec-image.png"
                alt="Quality Badge"
                className="w-24 h-24"
              />
            </div>
          </div>

          {/* Right Content - Service Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* 24 Hour Emergency Service */}
            <div className="relative">
              <div className="aspect-w-4 aspect-h-3 mb-4">
                <img
                  src="/25years.png"
                  alt="Emergency Service"
                  className="object-cover rounded-lg"
                />
              </div>
              <h3 className="text-xl font-bold mb-2">Emergency Service</h3>
              <p className="text-gray-600 mb-4">
                We are on the line 24 hour because we understand that our
                clients could need help any time. Please contact us and our
                emergency team will be at your place to resolve the issue. We
                are always on duty of your comfort and security!
              </p>
              <button className="text-orange-500 font-semibold hover:text-orange-600 transition-colors flex items-center">
                VIEW DETAILS
                <svg
                  className="w-5 h-5 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>

            {/* 25 Years Experience */}
            <div className="relative">
              <div className="aspect-w-4 aspect-h-3 mb-4">
                <img
                  src="/24hours.png"
                  alt="Years of Experience"
                  className="object-cover rounded-lg"
                />
              </div>
              <h3 className="text-xl font-bold mb-2">10 Years Experience</h3>
              <p className="text-gray-600 mb-4">
                Our company has a rich experience in welding services as we have
                been working since 2012. We know what our clients need and we
                are always ready to meet any demand. We love non-standard
                projects as we can show all the creative skills we have!
              </p>
              <button className="text-orange-500 font-semibold hover:text-orange-600 transition-colors flex items-center">
                VIEW DETAILS
                <svg
                  className="w-5 h-5 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experts;
